export default __webpack_public_path__ + "static/simple-scatter-c44896684d9466ea598bb2889fa3c508.png";